/* eslint-disable */
import React from 'react';

interface HeadingProps {
  Tag: string,
  children: string,
  addClasses: string
};

function Heading({ Tag = 'h2', children = '', addClasses = ''} : HeadingProps) {
  return React.createElement(
    Tag,
    {
      className: addClasses
    },
    children
  );
};

export default Heading;